// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2fbCr","clinicsSelect":"TableHeading_clinicsSelect__pBnZ4"};